import * as React from 'react'
import 'react-dates/initialize'
import styled from 'styled-components'
import * as interfaces from '../../../../static/interfaces'
import { ChatForm, Messages } from './atoms'

interface IProps {
  user: any
  initMessages: interfaces.IMessage[]
  conversationId: any
  note?: string
}

const FIELDS_MESSAGE = {
  file: 'file',
  body: 'body',
}

const BREAK_POINT = 768

const Chat: React.FC<IProps> = ({ user, initMessages, conversationId, note }) => {
  const [fetching, setFetching] = React.useState(false)
  const [messages, setMessages] = React.useState<interfaces.IMessage[]>([])

  const getIsSelf = React.useCallback(message => message.sender.id === user.id, [user])
  const addMessage = message => {
    const formatMessage = { ...message, isSelf: getIsSelf(message) }
    setMessages((currentMessages: interfaces.IMessage[]) => [formatMessage, ...currentMessages])
  }
  const onUpdate = () => location.reload()

  React.useEffect(() => {
    setMessages(initMessages.map(message => ({ ...message, isSelf: getIsSelf(message) })).reverse())
  }, [initMessages])

  return (
    <Thread>
      <ChatForm user={user} conversationId={conversationId} note={note} addMessage={addMessage} />
      <Messages user={user} messages={messages} fetching={fetching} onUpdate={onUpdate} />
    </Thread>
  )
}

const Thread = styled.div`
  flex: 1;
`
export default Chat
